import React from 'react';

const DiscountAmount = ({ rowData }) => {
    return (
        <span>
            {
            rowData.coupon_type === "p" ?
            `${rowData.percent} درصد` :
            `${rowData.amount.toLocaleString()} تومان`
            }
        </span>
    );
}

export default DiscountAmount;
